// The openers an empty account chat offers: the questions a strategist asks of every account.
// A click fills the composer; the strategist sends it. Pure, so `node --test` runs it.

export interface ChatStarter {
  title: string;
  prompt: string;
}

/** An AE's openers (20 Oct): about the deal, not outreach. `lib/roleViews.ts` picks these. */
export function aeDealChatStarters(companyName: string | null | undefined): ChatStarter[] {
  const company = companyName?.trim() || 'this account';
  return [
    { title: 'Where the deal stands', prompt: `Summarise where the deal with ${company} stands.` },
    { title: 'What we last discussed', prompt: `What did we last discuss with ${company}?` },
    { title: 'Prep the next meeting', prompt: `Prep me for my next meeting with ${company}.` },
  ];
}

/** Leadership's and viewers' openers on the oversight page: who, what happened, the deals. */
export function oversightChatStarters(companyName: string | null | undefined): ChatStarter[] {
  const company = companyName?.trim() || 'this account';
  return [
    { title: 'Who is working it', prompt: `Who's working ${company} and what's happened lately?` },
    { title: 'The open deals', prompt: `Summarise the open deals at ${company}.` },
    { title: 'Anyone else talking to them', prompt: `Is anyone else at Cartesia talking to ${company}?` },
  ];
}

/** "Why them" and "who to write to", for the account in view, after any opener the caller passes. */
export function accountChatStarters(companyName: string | null | undefined, callerStarters: ChatStarter[] = []): ChatStarter[] {
  const company = companyName?.trim() || 'this account';
  const asked: ChatStarter[] = [
    { title: 'Why this account', prompt: `Why should I reach out to ${company} now?` },
    { title: 'Who to write to', prompt: `Who should I talk to at ${company}, and why?` },
  ];

  // A caller's own opener with the same prompt is not offered twice.
  const callerPrompts = new Set(callerStarters.map(starter => starter.prompt));
  return [...callerStarters, ...asked.filter(starter => !callerPrompts.has(starter.prompt))];
}
